import type { IconName } from '@raiadrogasil/pulso-icons'
import { Icon, type TIconProps } from '~/components/icon'
import type { TIconSizes } from '~/components/icon/types'
import {
  DISPLAY_NAME,
  type ScopedProps,
  useContentContext,
} from '../../content'

interface IContentIconProps extends TIconProps {}

export function ContentIcon({ testID, symbol, ...props }: IContentIconProps) {
  const { __scopeContent } = props as ScopedProps<IContentIconProps>

  const { size } = useContentContext(DISPLAY_NAME, __scopeContent)

  const renderIconSize = (): TIconSizes => {
    if (size === 'default') {
      return 'extra-small'
    }
    return 'small'
  }

  const renderSymbolIcon = (): IconName => {
    if (!symbol) {
      return 'rdicon-default'
    }
    return symbol as IconName
  }

  return (
    <Icon
      symbol={renderSymbolIcon()}
      testID={testID}
      size={renderIconSize()}
      {...props}
    />
  )
}
